var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    statusId: undefined,
    selectedPositions: [],
    name: undefined
};
var filterSlice = createSlice({
    name: 'filter',
    initialState: initialState,
    reducers: {
        setStatusId: function (state, action) {
            state.statusId = action.payload;
        },
        setSelectedPositions: function (state, action) {
            state.selectedPositions = action.payload;
        },
        setName: function (state, action) {
            state.name = action.payload;
        },
        removeSelectedPosition: function (state, action) {
            state.selectedPositions = state.selectedPositions.filter(function (position) { return position !== action.payload; });
        },
        clearFilter: function (state) {
            state.selectedPositions = [];
            state.statusId = undefined;
            state.name = undefined;
        },
    },
});
export var setName = (_a = filterSlice.actions, _a.setName), setStatusId = _a.setStatusId, setSelectedPositions = _a.setSelectedPositions, removeSelectedPosition = _a.removeSelectedPosition, clearFilter = _a.clearFilter;
export default filterSlice.reducer;
